<div>
  <point-list-table
    [inspection]="inspection"
    [points]="points"
    [folders]="folders"
    (toggleOpenPoint)="openPoint($event)"
    (toggleOpenFolder)="openFolder($event)"
    (toggleSelectPoint)="selectPoint($event)"
    (toggleSelectFolder)="selectFolder($event)"
    [query]="query"
  ></point-list-table>
</div>
